export const validateEmail = (email) => {
    const trimmedEmail = email.trim(); // Trim whitespace
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/; // Email regex pattern
    const isValid = regex.test(trimmedEmail);
        return isValid;
  };
  